import type {
  DashboardMetricsDTO,
  MonthlyConversationsDTO,
  RecentAttendancesDTO,
} from '@/features/dashboard/types'
import { httpClient } from '@/lib/api'

export type DashboardDateRangeParams = {
  startDate?: string
  endDate?: string
}

export class DashboardService {
  public static async getMetrics(params?: DashboardDateRangeParams) {
    const { data } = await httpClient().get<DashboardMetricsDTO>('/metrics/overview', {
      params,
    })
    return data
  }

  public static async getMonthlyConversations(params?: DashboardDateRangeParams) {
    const { data } = await httpClient().get<MonthlyConversationsDTO>('/conversations/monthly', {
      params,
    })
    return data
  }

  public static async getRecentAttendances(params?: DashboardDateRangeParams) {
    const { data } = await httpClient().get<RecentAttendancesDTO>('/attendances/recent', {
      params,
    })
    return data
  }
}
